import { createApp } from 'vue'
import SearchProgram from '@/search_program'

document.addEventListener('DOMContentLoaded', () => {
  createApp({ components: { SearchProgram } }).mount('main')
})
